import { render, staticRenderFns } from "./Components4.vue?vue&type=template&id=abfe8968&scoped=true"
import script from "./Components4.vue?vue&type=script&lang=js"
export * from "./Components4.vue?vue&type=script&lang=js"
import style0 from "./Components4.vue?vue&type=style&index=0&id=abfe8968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfe8968",
  null
  
)

export default component.exports